import gql from 'graphql-tag'

export default gql`
mutation ($slug: String!) {
  exportDistrictStats(slug:$slug) {
    downloadUrl
  }
}
`
